import { DetailLabelBind } from "src/views/common/Common";

export const BidderDetail = (pData) => (
  <>
    <DetailLabelBind
      lable="Email Address"
      value={pData?.emailId && pData?.emailId}
    />
    <DetailLabelBind
      lable="Goods and Services"
      value={pData?.gst && pData?.gst}
    />
    <DetailLabelBind
      lable="Propritor Name"
      value={pData?.username && pData?.username}
    />
    <DetailLabelBind
      lable="Company Name"
      value={pData?.companyName && pData?.companyName}
    />
    <DetailLabelBind lable="Mobile" value={pData?.mobile && pData?.mobile} />
    <DetailLabelBind
      lable="Name of Forest Division Where Tenderer Registered"
      value={pData?.registeredDistrict && pData?.registeredDistrict}
    />
  </>
);
export const getPaymentTypeValue = (id) => {
  switch (id) {
    case 1:
      return "Payment Collected without GST";
    case 2:
      return "Payment Collected with GST";
    case 3:
      return "Only Collected GST";
    default:
      return "";
  }
};
export const getStatusValue = (id) => {
  switch (id) {
    case 1:
      return "Pending";
    case 2:
      return "Approved";
    case 3:
      return "Reject";
    case 4:
      return "Clarification";
    default:
      return "";
  }
};

export const valueSet = (data) => {
  return data && data;
};
